import { Component, Input } from '@angular/core';
import { ALERT_MODES } from 'src/app/_constants/app.constants';

@Component({
  selector: 'ua-alert-msg',
  templateUrl: './alert-msg.component.html',
  styleUrls: ['./alert-msg.component.scss']
})
export class AlertMsgComponent  {

  alertModes = ALERT_MODES;

  constructor() { }

  @Input() mode: string;
  @Input() title: string = '';
  @Input() message: string = '';


  

}
